import { Chip } from '@mui/material'

import { GetAllOfferRequestsForAdminOfferRequest } from '../../../../redux/states/admin/orders/getAllOfferRequestsForAdmin/getAllOfferRequestsForAdmin.types'
import { TableColumn } from '../../../../shared/components/Table/Table.types'
import date, { dateTimeFormats } from '../../../../shared/functions/Date/date.functions'
import { getStatusColor } from '../../../../shared/functions/Status/status.functions'

export const offerRequestTableColumns: TableColumn<GetAllOfferRequestsForAdminOfferRequest>[] = [
  {
    key: 'id',
    label: 'Order Number'
  },
  {
    key: 'createdAt',
    label: 'Created At',
    render: (row: GetAllOfferRequestsForAdminOfferRequest) => date(row.creationDate).format(dateTimeFormats.date.medium)
  },
  {
    key: 'source',
    label: 'Source',
    render: (row: GetAllOfferRequestsForAdminOfferRequest) => row.source.country.name
  },
  {
    key: 'destination',
    label: 'Destination',
    render: (row: GetAllOfferRequestsForAdminOfferRequest) => row.destination.country.name
  },
  {
    key: 'shopper',
    label: 'Shopper',
    render: (row: GetAllOfferRequestsForAdminOfferRequest) => row.shopper.firstName + ' ' + row.shopper.lastName
  },
  {
    key: 'shopperEmail',
    label: 'Shopper Email',
    render: (row: GetAllOfferRequestsForAdminOfferRequest) => row.shopper.email
  },
  {
    key: 'traveler',
    label: 'Traveler',
    render: (row: GetAllOfferRequestsForAdminOfferRequest) => {
      if (row.traveler) {
        return row.traveler.firstName + ' ' + row.traveler.lastName
      }

      return '-'
    }
  },
  {
    key: 'status',
    label: 'Status',
    render: (row: GetAllOfferRequestsForAdminOfferRequest) => (
      <Chip label={row.status.displayName || row.status.name} color={getStatusColor(row.status.name)} />
    )
  }
]
